import { render, staticRenderFns } from "./CrmBarChart.vue?vue&type=template&id=3f670876&"
import script from "./CrmBarChart.vue?vue&type=script&lang=js&"
export * from "./CrmBarChart.vue?vue&type=script&lang=js&"
import style0 from "./CrmBarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports